import { useMutation } from '@tanstack/react-query'
import { requestIndeedFlexOtpChallenge } from 'api/admin/indeedFlex/requestIndeedFlexOtpChallenge'

export const useRequestIndeedFlexOtpChallengeMutation = () => {
  return useMutation({
    mutationFn: requestIndeedFlexOtpChallenge,
  })
}
